import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: December 10, 2024</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <div className="section-number">1</div>
            <div className="section-content">
              <h2>Acceptance of Terms</h2>
              <p>
                By accessing and using the SyarTech mobile application and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use our services.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">2</div>
            <div className="section-content">
              <h2>Service Description</h2>
              <p>
                SyarTech provides on-demand car washing and detailing services throughout Egypt. Our services include:
              </p>
              <ul>
                <li>Express exterior wash</li>
                <li>Premium wash with interior cleaning</li>
                <li>Full detailing services</li>
                <li>Specialized cleaning treatments</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">3</div>
            <div className="section-content">
              <h2>User Responsibilities</h2>
              <p>As a user of our services, you agree to:</p>
              <ul>
                <li>Provide accurate vehicle and location information</li>
                <li>Ensure your vehicle is accessible at the scheduled time</li>
                <li>Remove all valuable items from your vehicle before service</li>
                <li>Notify us of any special conditions or requirements</li>
                <li>Pay for services in a timely manner</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">4</div>
            <div className="section-content">
              <h2>Booking and Cancellation</h2>
              <p>
                Bookings must be made through our mobile application. Cancellations made at least 2 hours before the scheduled service time are eligible for a full refund. constant Late cancellations or no-shows may be subject to denial of service.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">5</div>
            <div className="section-content">
              <h2>Payment Terms</h2>
              <p>
                Payment is accepted through our app via credit/debit cards, or mobile wallets. All prices are in Egyptian Pounds (EGP) and include applicable taxes. We reserve the right to modify our pricing with reasonable notice.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">6</div>
            <div className="section-content">
              <h2>Liability and Insurance</h2>
              <p>
                While we take utmost care in providing our services, SyarTech is not liable for:
              </p>
              <ul>
                <li>Pre-existing damage to the vehicle</li>
                <li>Items left inside the vehicle</li>
                <li>Damage resulting from improper vehicle maintenance</li>
                <li>Delays caused by weather conditions or circumstances beyond our control</li>
              </ul>
              <p>
                Our professional teams are trained and insured. Any damage caused by our service will be assessed and compensated according to our insurance policy.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">7</div>
            <div className="section-content">
              <h2>Service Quality Guarantee</h2>
              <p>
                We are committed to providing high-quality service. If you are not satisfied with our service, please contact us within 24 hours of service completion. We will work with you to resolve any issues or offer a complimentary re-service.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">8</div>
            <div className="section-content">
              <h2>Privacy and Data Protection</h2>
              <p>
                Your privacy is important to us. We collect and use your personal information in accordance with our Privacy Policy. By using our services, you consent to our data collection and use practices as described in our Privacy Policy.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">9</div>
            <div className="section-content">
              <h2>Prohibited Activities</h2>
              <p>Users are prohibited from:</p>
              <ul>
                <li>Using the service for illegal purposes</li>
                <li>Attempting to interfere with the app's functionality</li>
                <li>Harassing or threatening our staff</li>
                <li>Providing false information</li>
                <li>Reselling our services without authorization</li>
              </ul>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">10</div>
            <div className="section-content">
              <h2>Modifications to Terms</h2>
              <p>
                SyarTech reserves the right to modify these terms at any time. We will notify users of significant changes through the app or email. Continued use of our services after changes constitute acceptance of the modified terms.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">11</div>
            <div className="section-content">
              <h2>Governing Law</h2>
              <p>
                These terms are governed by the laws of the Arab Republic of Egypt. Any disputes arising from these terms or our services shall be resolved in Egyptian courts.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <div className="section-number">12</div>
            <div className="section-content">
              <h2>Contact Information</h2>
              <p>
                For questions or concerns about these terms, please contact us at:
              </p>
              <ul>
                <li>Website: <a href="https://kamshka.com/contact" target="_blank" rel="noopener noreferrer">kamshka.com/contact</a></li>
                <li>Facebook: <a href="https://www.facebook.com/profile.php?id=61584276933010" target="_blank" rel="noopener noreferrer">SyarTech Egypt</a></li>
                <li>Instagram: <a href="https://www.instagram.com/car_washeg/" target="_blank" rel="noopener noreferrer">@car_washeg</a></li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
